// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SVFoy","links":"styles_links__3zIpu","logo":"styles_logo__veIfH","active":"styles_active__bZEWb","rightSide":"styles_rightSide__StFfh"};